/**
 * Issues Found During Service section for PM Inspection Process.
 * Issue Description text field and "Create Issue Ticket" checkbox.
 *
 * Validates: Requirements 9.9, 15.1, 15.2
 */

export interface IssuesFoundData {
    issueDescription: string;
    createIssueTicket: boolean;
}

interface IssuesFoundSectionProps {
    data: IssuesFoundData;
    onChange: (data: IssuesFoundData) => void;
}

export const IssuesFoundSection = ({
    data,
    onChange,
}: IssuesFoundSectionProps) => {
    return (
        <div className="pm-inspection-section">
            <h3 className="pm-inspection-section-title">Issues Found During Service</h3>

            <div className="pm-inspection-field">
                <label className="pm-inspection-label" htmlFor="pm-issue-description">
                    Issue Description
                </label>
                <textarea
                    id="pm-issue-description"
                    className="pm-inspection-textarea"
                    rows={4}
                    placeholder="Describe any issues found during service…"
                    value={data.issueDescription}
                    onChange={(e) =>
                        onChange({ ...data, issueDescription: e.target.value })
                    }
                />
            </div>

            <div className="pm-inspection-checkbox-row">
                <input
                    id="pm-create-issue-ticket"
                    type="checkbox"
                    className="pm-inspection-checkbox"
                    checked={data.createIssueTicket}
                    onChange={(e) =>
                        onChange({ ...data, createIssueTicket: e.target.checked })
                    }
                />
                <label htmlFor="pm-create-issue-ticket" className="pm-inspection-checkbox-label">
                    Create Issue Ticket
                </label>
            </div>
        </div>
    );
};
